import { createServerFn } from "@tanstack/react-start";
import type { BlogPost } from "@/data/site/blog";

export const listWpBlogPosts = createServerFn({ method: "GET" }).handler(
  async (): Promise<BlogPost[]> => {
    const { listWpBlogPostsFromDatabase } = await import("./wpBlog.server");
    return listWpBlogPostsFromDatabase();
  },
);
